const PROPERTY_TYPE = {

  id: "property_type",
  type: "dropdown",
  props: {
    isMulti: false,
    dropdownProps: {
      label: "Property Type",
      buttonProps: {
        className: "property_type",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "Condominium", value: "Residential" },
      { label: "Executive Condominium", value: "Executive Condominium" },
      { label: "Landed", value: "Landed" },
      { label: "Commercial", value: "Commercial" },
      { label: "Industrial", value: "Industrial" },
    ]
  }

}

const COL_PROPERTY_TYPE = {

  id: "col_property_type",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [PROPERTY_TYPE]

}

const COL_MODAL_PROPERTY_TYPE = {

  id: "col_property_type",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [PROPERTY_TYPE]

}

export { PROPERTY_TYPE, COL_PROPERTY_TYPE, COL_MODAL_PROPERTY_TYPE };
